import { getInitialData, logoutUser } from "../../services/auth/auth.service";
import { getLeaveList } from "../../services/workspace/leave.service";
import { fetchProfileData, getUserList } from "../../services/workspace/user.service";
import { _setProfileLoad, _setUserData, fetchUserProfile, _logoutUser as _logoutUserReducer } from "../slices/user.slice";
import { resetStore } from "../store";
import { removeItem } from "../../utils/localStorage";

export const _fetchUserData = () => async (dispatch) => {
    try {
        // Use the new fetchUserProfile action which handles loading states automatically
        const result = await dispatch(fetchUserProfile());
        
        // Handle the result if needed
        if (fetchUserProfile.fulfilled.match(result)) {
            // Profile fetched successfully
        } else if (fetchUserProfile.rejected.match(result)) {
            // Handle error
            console.error('Failed to fetch user profile:', result.payload);
        }
        return result; // Return the result so callers can use .finally() or .then()
    } catch (error) {
        console.error('An error occurred while fetching user data:', error);
        throw error; // Re-throw to propagate the error
    }
};

export const _fetchLeaveData = (params, callback = () => null) => async (dispatch) => {
    try {
        const response = await getLeaveList(params);
        if (response) {
            callback(false, response)
        }
    } catch (error) {
        callback(true, error)
        console.error("An error occurred while fetching the leave data:", error);
    }
};

// Note: _fetchTimeTableData removed as timetable.service is not available for HR management system

export const _logoutUser = (data, callback = () => null) => async (dispatch) => {
    try {
        const res = await logoutUser(data);
        // Clear token from localStorage first
        removeItem("user");
        // Reset entire store (this resets to initial state where loading: true)
        dispatch(resetStore());
        // Then clear user state and set loading to false (after reset)
        dispatch(_logoutUserReducer());
        callback(false, res);
    } catch (error) {
        // Even on error, clear the state to allow login
        removeItem("user");
        dispatch(resetStore());
        dispatch(_logoutUserReducer());
        callback(true, error);
        console.error("An error occurred during logout:", error);
    }
};

export const _fetchUserList = (params, callback = () => null) => async (dispatch) => {
    try {
        const response = await getUserList(params);
        if (response) {
            callback(false, response)
        }
    } catch (error) {
        callback(true, error)
        console.error("An error occurred while fetching the leave data:", error);
    }
};